/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { useState } from "react";
import { Button } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { toast } from "react-toastify";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { urlEnum } from "../../../Utils/urlEnum";
import { updateData } from "../../../Services/updateData";
import VehicleSearchModal from "../../Generic/VehicleSearchModal";

interface AssociateVehicleButtonProps {
  leadId: number;
  onAssociated: (vehicle: any) => void;
}

export default function AssociateVehicleButton({
  leadId,
  onAssociated,
}: AssociateVehicleButtonProps) {
  const [open, setOpen] = useState(false);

  async function handleSelectVehicle(vehicle: any) {
    setOpen(false);
    try {
      await updateData(`${urlEnum.clientMessages}/${leadId}`, {
        vehicul_id: vehicle.id,
      });
      onAssociated(vehicle);
    } catch {
      toast.error(Vocabulary.updateError);
    }
  }

  return (
    <>
      <Button
        fullWidth
        variant="contained"
        startIcon={<DirectionsCarIcon sx={{ fontSize: "17px !important" }} />}
        onClick={() => setOpen(true)}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 700,
          fontSize: 13,
          py: 1.25,
          bgcolor: "#FF6B1A",
          color: "#fff",
          boxShadow: "0 2px 8px rgba(255,107,26,0.3)",
          "&:hover": {
            bgcolor: "#e85c0f",
            boxShadow: "0 4px 14px rgba(255,107,26,0.4)",
          },
        }}
      >
        {Vocabulary.associateWithVehicle || "Asociează cu un vehicul"}
      </Button>

      <VehicleSearchModal
        open={open}
        onClose={() => setOpen(false)}
        onSelectVehicle={handleSelectVehicle}
      />
    </>
  );
}
